import plugins from './plugins';
import MobxReactForm from "mobx-react-form";
import {updateCardRules, updateCardTypeRules, updatePostalCodeRules} from "./helpers";


const fields = {
    cardType: {
        label: 'enrollment:cardtype',
        rules: 'string|required',
        placeholder: 'enrollment:cardtype',
    },
    cardNumber: {
        label: 'enrollment:cardnumber',
        rules: 'string|required',
        placeholder: 'enrollment:cardnumber',
        "extra": "#### #### #### ####"
    },
    cardExpMonth: {
        label: 'enrollment:expmonth',
        rules: 'integer|required|max:12',
        placeholder: 'enrollment:expmonth',
    },
    cardExpYear: {
        label: 'enrollment:expyear',
        placeholder: 'enrollment:expyear',
        rules: 'integer|required',
    },
    cardCode: {
        label: 'enrollment:securitycode',
        rules: 'string|required',
        placeholder: 'enrollment:securitycode',
    },
    country: {
        rules: 'string'
    }
};



export default function create(initials, hooks) {
    let f = { ...fields };
    if (initials) {
        Object.keys(initials).forEach(k => {
            if (f[k])
                f[k].value = initials[k];
        });
    }
    const form = new MobxReactForm({ fields: f }, { plugins, hooks });

    form.$('country')
    .observe(({ form, field, change }) => {
        updateCardTypeRules(form, field.value);
    });
    updateCardTypeRules(form, initials.country);

    form.$('cardType')
        .observe(({ form, field, change }) => {
            updateCardRules(form, field.value);
        });

    const initCardType = !!initials && initials.cardType ? initials.cardType : "";
    updateCardRules(form, initCardType);

    return form;
}
